import { render, staticRenderFns } from "./BooksReport.vue?vue&type=template&id=aaf02af4&scoped=true&"
import script from "./BooksReport.vue?vue&type=script&lang=js&"
export * from "./BooksReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaf02af4",
  null
  
)

export default component.exports